module.exports = __webpack_public_path__ + "img/good3.025222e9.png";